module.exports = __webpack_public_path__ + "img/parma.fefaa851.png";